<template lang="pug">
  div(@click="$router.push(`/tutorial/event/${content.id}`)").wrap-item-suggested-event-card.py8
    div.card-content.f
      div.event-info
        div.f.fm.flex-between.mb4
          span.block.bold.fz16 {{content.title}}
          span.fz12 {{trainingTime}}
        div.f.fm.flex-between
          div(v-if="trainer").f.fm
            v-avatar(size="28px").mr6
              v-img(:src="trainer.photoURL")
            span.fz12 {{trainer.name}}
          span.text-detail.fz12 詳しく
          //- span.fz12 {{trainingTime}}
      div.check-box.f.fm.flex-right
        div
          div.f.fc
            v-icon(@click.stop="attend = !attend"
              :color="(attend) ? '#1976d2' : '#ccc'").mb4 check
          span.block.fz10 {{(attend) ? '予約済み' : '予約する'}}
        //- v-checkbox(v-model="attend")
</template>

<style lang="scss" scoped>
.wrap-item-suggested-event-card {
  border-bottom: solid rgba(0, 0, 0, 0.2) 0.4px;
  .card-content {
    margin: 0 auto;
    width: 93%;
    max-width: 820px;
    .text-detail {
      color: #1976d2;
    }
    .event-info {
      width: calc(100% - 48px)
    }
    .check-box {
      width: 48px;
    }
  }
}
</style>

<script>
import db, { api } from "@/components/utils/firebase"
import { sendTrackingEvent } from "@/components/utils/eventTracker"
import format from "date-fns/format"
import { createNamespacedHelpers } from "vuex"
const { mapState: mapStateAuth } = createNamespacedHelpers("auth")

export default {
  components: {
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      trainer: null,
      trainingTime: null,
      attend: null
    }
  },
  computed: {
    ...mapStateAuth(["uid"]),
    // trainingTime: () => {
    //   var start = format(new Date(this.content.startTime.toDate()), "M/d hh:mm")
    // }
  },
  watch: {
    async attend (newVal, oldVal) {      
      let params = {
        uid: this.uid,
        eventId: this.content.id   
      }
      params.willAttend = this.attend
      
      const response = await fetch(`${api}/toggleAttendeeStatus`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(params)
      })
      let result = await response.json()
      console.log("result:", result)

      let trackingMessage = (this.attend) ? "Reserve Training" : "Cancel Training"

      sendTrackingEvent(trackingMessage, {
        uid: this.uid,
        eventId: this.content.id,
        title: this.content.title,
        level: this.content.level,
        startTime: this.content.startTime.toDate(),
        endTime: this.content.endTime.toDate(),
        trainer: this.content.trainer,
        room: this.content.roomURL,
        path: this.$route.name
      }, this.uid)
    }
  },
  async created () {
    this.attend = true

    const start = format(new Date(this.content.startTime.toDate()), "M/d hh:mm")
    const end = format(new Date(this.content.startTime.toDate()), "hh:mm")
    this.trainingTime = `${start} ~ ${end}`

    this.trainer = await db.collection("TRAINER")
      .doc(this.content.trainer)
      .get()
      .then(d => { return d.data() })
  },
  methods: {

  }
}
</script>
